import { Action, Link } from '@/types/general';
import { LegalFormNonRegistered } from '@/types/partnership';

export interface Mandate {
  name: string;
  familyName: string;
  gender: string;
  dateOfBirth: string;
  town: string;
  zip: string;
  placeOfOrigin: string;
  empowerment: string;
}

interface Assessment {
  assessment: string;
  assessmentTime: string;
}

export enum PartnershipDeclarationStatus {
  New = 'new',
  Cancelled = 'cancelled',
  Certification = 'certification',
  CertIssues = 'certification issues',
  CertFailed = 'certification failed',
  Certified = 'certified'
}

export interface PartnershipDeclaration {
  identity: {
    name: string;
    purpose: string;
    identifiers?: any;
    legalForm: string;
    nogaCodes: Array<string>;
    nogaCodes_loc?: Array<string>;
  };
  postalAddress: {
    country: string;
    street: string;
    houseNo: string;
    zip: string;
    town: string;
  };
  phoneNumber: {
    countryCode: string;
    number: string;
  };
  email: string;
  webpage: string;
  logo: string;
  logoFileName?: string;
  remarks?: string;
  declarationEvidenceReferences?: Array<{ name: string }>;
  mandates: Array<Mandate>;
  status: string;
  assessments?: Array<Assessment>;
  _links: {
    self: Link;
  };
  _actions: {
    edit?: Action;
    delete?: Action;
    submit?: Action;
  };
}

export interface PartnershipDeclarationList {
  identity: {
    legalForm: LegalFormNonRegistered;
    name: string;
  };
  numMandates: number;
  numReports: number;
  partnershipDeclarationHandle: string;
  status: PartnershipDeclarationStatus;
}
